import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, MenuItem, Stack } from "@mui/material";
import { RFHTextField, RHFSelect } from '../../../components/RFH';
import { useQueryClient, useMutation } from "@tanstack/react-query";

import { schema } from "../../../schemas/createBoard";
import { useWorkflow } from "../../../utils/reactQuery/workflows";
import { useUsers } from "../../../utils/reactQuery/users";
import { createBoard } from "../../../sevices/apiBoards";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import useToastPromise from "../../../hooks/useToast";
import CustomMenu from "../../../components/Menu";
import CustomMenuItem from "../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../components/Button/Button";

function Form({ onClose }) {
  const queryClient = useQueryClient();
  const {
    isLoading: isWorkflowLoading,
    workflows,
    isError: isWorkflowError,
  } = useWorkflow();
  const { isLoading: isUserLoading, users, isError: isUserError } = useUsers();
  const [workflowOption, setWorkFlowOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const navigate = useNavigate();
  const { showToastPromise } = useToastPromise();

  const accessOption = [
    {
      label: "Private",
      value: "true",
    },
    {
      label: "Public",
      value: "false",
    },
  ];
  

  useEffect(() => {
    if (!isWorkflowLoading && !isWorkflowError) {
      setWorkFlowOption(
        workflows.data.data.responseData.map((el) => {
          return { label: el.workflow_name, value: el.workflow_id };
        })
      );
    }
  }, [isWorkflowLoading, workflows]);

  useEffect(() => {
    if (!isUserLoading && !isUserError) {
      let filteredArray = users.data.data.responseData
        .filter((el) => el.active)
        .sort(function (a, b) {
          return a.first_name.localeCompare(b.first_name);
        });
      setUserOption(
        filteredArray.map((el) => {
          return {
            label: `${el.first_name} ${el.last_name}`,
            value: el.user_id,
          };
        })
      );
    }
  }, [users, isUserLoading]);

  // React Hook Form
  const { handleSubmit, reset, ...methods } =
    useForm({
      defaultValues: {
        is_archive: false,
      },
      resolver: yupResolver(schema),
    });

  const { mutate: createBoardMutate, isPending : loading } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(createBoard, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ["boards"],
      });
      reset();
      onClose();
      navigate(`/board/${res.data.data.responseData.new_board_id}`);
    },
    onError: (error) => {
      console.error("Error Create Boards", error);
      //toast.error(error.response.data.message);
    },
  });

  const submit = (data) => {
    data.is_private = data?.is_private === "true" ? true : false;
    createBoardMutate(data);
  };

  return (
    <>
      <FormProvider {...methods}>
        <Box
          component="form"
          onSubmit={handleSubmit(submit)}
          noValidate
          className="form-container"
        >
          <Stack spacing={3}>
       
            <RFHTextField
              name="board_name"
              label={"Board Name"}
              className="board-name-field"
              required
            />

            <RHFSelect
              name="workflow_id"
              label={"Board Workflow"}
              className="board-name-field"
              required
            >
              {workflowOption.map((option) => (
                <CustomMenuItem
                  key={`workflow-option-${option.value}`}
                  id={`workflow-option-id-${option.value}`}
                  value={option.value}>
                  {option.label}
              </CustomMenuItem>
            ))}
            </RHFSelect>

            <RHFSelect
              name="owner_user_id"
              label={"Board Owner"}
              className="board-name-field"
              required
            >
              {userOption.length ? (
                userOption.map((option) => (
                  <CustomMenuItem
                    key={`user-option-${option.value}`}
                    id={`user-option-id-${option.value}`}
                    value={option.value}> 
                    {option.label}
                  </CustomMenuItem>
                ))
              ) : (
                <div className="loader-center">
                  <Loader color={"black"} />
                </div>
              )}
            </RHFSelect>

            <RHFSelect
              name="is_private"
              label={"Access"}
              className="board-name-field"
              required
            >
              {accessOption.map((option) => (
                <CustomMenuItem
                  key={`access-option-${option.value}`}
                  // id={`access-option-id-${option.value}`}
                  value={option.value}>
                  {option.label}
                </CustomMenuItem>
              ))}
            </RHFSelect>

            <Box className="button-container d-flex">
              <CustomButton
                type="submit"
                variant="contained"
                className="create-button"
                disabled={loading}>
                Create
              </CustomButton>
              <CustomButton
                variant="outlined"
                className="cancel-button"
                onClick={onClose}
                disabled={loading}>
                Cancel
              </CustomButton>
            </Box>
          </Stack>
        </Box>
      </FormProvider>
    </>
  );
}

export default Form;